import { Button, CircularProgress, Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { useDialogProps } from "legacy-components/dialog/Dialog";
import { useAsyncAction } from "modus/components/form/async-actions/AsyncAction";
import ConsentApprovalService from "pages/home/applications/services/ConsentApprovalService";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useCurrentTeam } from "libs/security/authorization/Permission";

interface ConsentRejecterProps {
  reason: string;
  resourceId: string;
  reloadNotificationList: () => void;
}
export const ConsentRejecter: React.FC<ConsentRejecterProps> = ({
  reason,
  resourceId,
  reloadNotificationList
}) => {
    const { open, toggle } = useDialogProps();
  const { teamId: storedTeamId } = useCurrentTeam();
  const currentTeamId = useSelector(
    (state: any) =>
      state?.teamManager?.teams?.currentTeam?.id ??
      storedTeamId
  );

  const { state, subscribe } = useAsyncAction(() =>
    ConsentApprovalService.deny(
      {
        reason: "DENIED",
        resourceName: resourceId,
      },
      {
        teamId: currentTeamId,
        type: "CONSENT",
      }
    ),
     {
        map: (value) => {
            
                toggle();
            
            return value;
        },
    }
  );

  const handleSubmit = (event: React.MouseEvent<HTMLButtonElement>) => {
   
    subscribe();
  };

 const reload = () => {
    toggle();
    reloadNotificationList();
  };

  return (
    <>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={reload}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <>
          <Alert severity="success" onClose={reload}>
            User Consent is Denied
          </Alert>
        </>
      </Snackbar>
      <Button
        disabled={state?.loading || reason === "" || reason === undefined}
        onClick={handleSubmit}
        color="secondary"
        variant="outlined"
      >
        {state?.loading && <CircularProgress className="action-loader" />}
        Reject
      </Button>
    </>
  );
};
